var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminpanelicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.4901 2.22957L5.50015 4.09958C4.35015 4.52958 3.41016 5.88957 3.41016 7.11957V14.5496C3.41016 15.7296 4.19017 17.2796 5.14017 17.9896L9.44016 21.1996C10.8502 22.2596 13.1701 22.2596 14.5801 21.1996L18.8802 17.9896C19.8302 17.2796 20.6101 15.7296 20.6101 14.5496V7.11957C20.6101 5.88957 19.6701 4.52958 18.5201 4.09958L13.5302 2.22957C12.6802 1.91957 11.3201 1.91957 10.4901 2.22957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9003 11.3003C11.9203 11.3003 11.9403 11.3003 11.9603 11.3003H11.9803H12.0003C13.1503 11.2603 14.0503 10.3303 14.0603 9.17027C14.0603 7.99027 13.1003 7.03027 11.9203 7.03027C10.7403 7.03027 9.78027 7.99027 9.78027 9.17027C9.80027 10.3203 10.7003 11.2603 11.9003 11.3003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1902 13.4105C12.9802 12.6105 11.0201 12.6105 9.80014 13.4105C9.24014 13.7905 8.91016 14.3305 8.91016 14.8905C8.91016 15.4605 9.23014 15.9805 9.80014 16.3605C10.4101 16.7605 11.2001 16.9705 11.9901 16.9705C12.7801 16.9705 13.5801 16.7705 14.1801 16.3605C14.7401 15.9805 15.0702 15.4405 15.0702 14.8805C15.0802 14.3105 14.7602 13.7905 14.1902 13.4105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminpanelicon);
export default __webpack_public_path__ + "static/media/admin panel icon.d0373f7d27e40390b822c8bfa4fee85c.svg";
export { ForwardRef as ReactComponent };